/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum Environment {
  LOCALHOST = "LOCALHOST",
  PINTLAB = "PINTLAB",
  DEV = "DEV",
  STAGING = "STAGING",
  PROD = "PROD",
}
